export const languageStringsAdmin = {
  title: "Klienti",
  pricingPeriod: {
    monthly: "Měsíční",
    yearly: "Roční",
  },
  table: {
    email: "Email",
    fullName: "Celé jméno",
    accountType: "Typ účtu",
    websites: "Weby",
    campaigns: "Kampaně",
    subscription: "Předplatné",
    takeControl: "Převzít kontrolu",
    loginButton: "Přihlásit se",
    noSubscription: "-------",
  },
  tools: {
    button: "Admin nástroje",
    modalTitle: "Administrativní nástroje",
    title: "Administrativní nástroje",
    clearCache: "Vymazat cache",
    error: "Chyba při provádění akce",
    clearGoogleReviewsCache: {
      title: "Vymazat cache Google recenzí",
      description:
        "Vymaže všechna cachovaná data Google recenzí pro všechny weby. Recenze budou znovu načteny při dalším požadavku v jazyce, který má web nastavený.",
      success: "Cache Google recenzí byla úspěšně vymazána",
    },
  },
  errorLogs: {
    button: "Chybové logy",
    title: "Chybové logy (frontend)",
    empty: "Žádné chyby nebyly zaznamenány.",
  },
};
